export enum SupportedPlaybookTypes {
  BOT = 'BOT',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
}

export enum CtaTypes {
  CHAT = 'CHAT_RESPONSE',
  URL = 'URL_LINK',
  MEETING = 'SCHEDULE_MEETING',
  NONE = 'NONE',
}

export type CQLScore = -1 | 1 | 2 | 3

export const PlaybookCollaboratorAccess = {
  RESTRICTED: 'RESTRICTED',
  VIEW: 'VIEW',
  COMMENT: 'COMMENT',
} as const

export type PlaybookCollaboratorAccess = keyof typeof PlaybookCollaboratorAccess
